// import PropTypes from "prop-types"
import React, { useEffect, useMemo, useRef, useState } from "react"
import { Col, Row, Input, Form, FormFeedback, Button, Spinner, Table } from "reactstrap";
import { Label, InputGroup, Card, CardBody, Tooltip } from "reactstrap";
import * as Yup from "yup";
import { useFormik, FieldArray, FormikProvider } from "formik";
import fn_helper from "helpers/fn_helper";
import PopupAttachment from "components/Input/attachment/PopupAttachment";
import InputText from "components/Input/InputText";

const LinkOut = ({
    validation,
    pageView
}) => {
    return(
        <>
            <Col className="col-12 mb-3">
                <label
                    htmlFor="businessName"
                    className="col-md-12 col-form-label"
                >
                    Business Name
                    <span className="t-require">*</span>
                </label>
                <div className="col-md-12">
                    <InputText
                        id="businessName"
                        className="form-control"
                        type="text"
                        placeholder=""
                        name="businessName"
                        onChange={e => {
                            validation.setFieldValue(
                                "businessName",
                                e.target.value
                            )
                        }}
                        onBlur={validation.handleBlur}
                        value={validation.values.businessName}
                        invalid={
                            validation.touched.businessName &&
                                validation.errors.businessName
                                ? true
                                : false
                        }
                        disabled={pageView === "view"}
                        maxLength={9999}
                    />
                    {validation.touched.businessName &&
                        validation.errors.businessName && (
                            <FormFeedback type="invalid">
                                {validation.errors.businessName}
                            </FormFeedback>
                        )}
                </div>
                <hr />
            </Col>
            <Col className="col-12 mb-3">
                <label
                    htmlFor="contentLinkout"
                    className="col-md-12 col-form-label"
                >
                    Link Out
                    <span className="t-require">*</span>
                </label>
                <div className="col-md-12">
                    <InputText
                        id="contentLinkout"
                        className="form-control"
                        type="text"
                        placeholder=""
                        name="contentLinkout"
                        onChange={e => {
                            validation.setFieldValue(
                                "contentLinkout",
                                e.target.value
                            )
                        }}
                        onBlur={validation.handleBlur}
                        value={validation.values.contentLinkout}
                        invalid={
                            validation.touched.contentLinkout &&
                                validation.errors.contentLinkout
                                ? true
                                : false
                        }
                        disabled={pageView === "view"}
                        maxLength={9999}
                    />
                    {validation.touched.contentLinkout &&
                        validation.errors.contentLinkout && (
                            <FormFeedback type="invalid">
                                {validation.errors.contentLinkout}
                            </FormFeedback>
                        )}
                        <span className="t-require">*</span><span>กรุณาใส่ข้อมูล https:// ด้วยเสมอ</span>
                </div>
                <hr />
            </Col>
            <Col className="col-6 mb-3">
                <div className="col-md-12">
                    <PopupAttachment
                        typeDetail="single"
                        typeUpload="ImageMap"
                        upload="Image"
                        prefixName="page-thumbnail"
                        label="Thumbnail image"
                        required={true}
                        description="description"
                        widthSize={888}
                        heightSize={479}
                        value={validation.values.thumbnail}
                        onChange={(value = {}, index) => {
                            console.log("🚀 onChange ~ value:", value)
                            console.log("🚀 onChange ~ index:", index)
                            validation.setFieldValue('thumbnail', value)
                        }}
                        onRemove={(index) => {
                            console.log("🚀 onChange ~ index:", index)
                            validation.setFieldValue('thumbnail', {})
                        }}
                    />
                    {validation.touched.thumbnail && validation.errors.thumbnail && (
                        <div type="invalid" className="invalid-feedback d-block">
                            {validation.errors.thumbnail}
                        </div>
                    )}
                </div>
                <hr />
            </Col>
        </>
    )
}
export default LinkOut